import get from 'lodash/get';
import { NOTIFICACTIONS_MANAGER_STATE } from '../constants';

export const resolvedNotificationIdSelector = state => {
  const notificationsManagerState = state[NOTIFICACTIONS_MANAGER_STATE];
  return get(notificationsManagerState, 'resolvedParams.notificationId');
};

export const resolvedEmailSelector = state => {
  const notificationsManagerState = state[NOTIFICACTIONS_MANAGER_STATE];
  return get(notificationsManagerState, 'resolvedParams.email');
};

export const resolvedUserControlTokenSelector = state => {
  const notificationsManagerState = state[NOTIFICACTIONS_MANAGER_STATE];
  return get(notificationsManagerState, 'resolvedParams.userControlToken');
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/resolvedParams/selectors.js